import { GrayButton } from 'components/Button'
import Column from 'components/Column'
import InputContainer from 'components/InputContainer'
import Row from 'components/Row'
import Text from 'components/Text'
import productName from 'constants/productName'
import { selectors } from 'data'
import messages from 'lang'
import isNil from 'lodash/isNil'
import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { connect, ConnectedProps } from 'react-redux'
import styled from 'styled-components'

import Container from '../Modal/Container'
import { SeedBackupCodes } from '../Modal/TwoFactor'

const StyledInputContainer = styled(InputContainer)`
  flex-direction: row;
  justify-content: center;
`

const PrintText = styled(Text)`
  &:hover {
    cursor: pointer;
  }
`

const PrintView = styled(Row)`
  display: none;

  @media print {
    display: flex;
  }
`

const ProductText = styled(Text)`
  margin-left: 0.5rem;
`

type PropsType = ConnectedProps<typeof connector> & WrappedComponentProps

const printCodes = () => window.print()

const DisplayCodes = ({ email, intl }: PropsType) => (
  <>
    <PrintView justifyContent='space-between'>
      <Column>
        <Row alignItems='center'>
          <ProductText color='black'>{productName}</ProductText>
        </Row>
      </Column>
      {!isNil(email) && (
        <Row alignItems='center'>
          <Text color='black'>{email}</Text>
        </Row>
      )}
    </PrintView>

    <Container
      sub={intl.formatMessage(messages.sub_title_backup_2fa)}
      title={intl.formatMessage(messages.title_backup_2fa)}
    >
      <Column>
        <InputContainer>
          <SeedBackupCodes />
        </InputContainer>

        <StyledInputContainer>
          <Text color='dark200' size='sm'>
            {intl.formatMessage(messages.description_backup_2fa)}&nbsp;
          </Text>
          <PrintText color='blue600' onClick={printCodes} size='sm'>
            {intl.formatMessage(messages.description_backup_2fa_print)}
          </PrintText>
        </StyledInputContainer>

        <GrayButton e2e='generateNewCodesButton' type='submit'>
          {intl.formatMessage(messages.button_generate_new_codes)}
        </GrayButton>
      </Column>
    </Container>
  </>
)

const mapStateToProps = (state) => ({
  email: selectors.auth.getEmail(state)
})

const connector = connect(mapStateToProps)

export default connector(injectIntl(DisplayCodes))
